import {Form, Formik} from "formik";
import React from "react";
import Card from "../../components/card/Card";
import ModalMsg from "../../components/ModalMsg";
import NsButtonNavigazione from "../../components/buttons/NsButtonNavigazione";
import NsDataTable from "../../components/tabelle/NsDataTable";
import NsButtonActionsGroup from "../../components/buttons/NsButtonActionsGroup";
import NsButtonAction from "../../components/buttons/NsButtonAction";
import ModalConfirm from "../../components/ModalConfirm";
import {Tag} from "primereact/tag";
import {getSeverityRuolo} from "../../utility/common";
import {NsCard} from "../../components/card/NsCard";
import NsField from "../../components/fields/NsField";
import ModalPermessiController from "../gruppi-utente/components/ModalPermessiController";

export default function ModificaUtenteView({
                                               utente,
                                               gruppiUtente,
                                               show,
                                               setShow,
                                               modalMsg,
                                               showConfirmGruppoDel,
                                               setShowConfirmGruppoDel,
                                               translate,
                                               gruppoSel,
                                               showPermessi,
                                               setShowPermessi,
                                               idGruppoSel,
                                               idUsr,
                                               formikRef,
                                               formikRefGruppi,
                                               SignupSchema,
                                               isRuoloSuperAdmin,
                                               isIdRuoloOperatore,
                                               optionsRuoli,
                                               optionsGruppi,
                                               statiUtenteAttivo,
                                               handleOkConfirmElimina,
                                               bottoniSx,
                                               bottoniDx,
                                               initialValuesForm,
                                               initialValuesFormGrupi,
                                               onSubmitForm,
                                               onSubmitFormGruppi,
                                               onClickAggiungiGruppo,
                                               onClickVisualizzaPermessi,
                                               onClickEliminaGruppo,
                                           }) {

    return (
        <div>
            <ModalMsg
                show={show}
                handleClose={() => setShow(false)}
                testo={modalMsg}/>
            <ModalConfirm
                show={showConfirmGruppoDel}
                handleClose={() => setShowConfirmGruppoDel(false)}
                handleOk={handleOkConfirmElimina}
                testo={translate("Sicuro di voler eliminare la relazione tra l'utente ed il gruppo: ") + (gruppoSel && gruppoSel.descrizione) + "?"}/>
            <ModalPermessiController
                show={showPermessi}
                handleClose={() => setShowPermessi(false)}
                idGruppo={idGruppoSel}
            />
            <Card
                icon={'fas fa-user'}
                title={idUsr ? 'Modifica Utente' : 'Inserisci Utente'}
                bottoniSx={bottoniSx}
                bottoniDx={bottoniDx}
            >
                <Formik
                    initialValues={initialValuesForm}
                    innerRef={formikRef}
                    validationSchema={SignupSchema}
                    onSubmit={onSubmitForm}
                >
                    {({values, errors, touched, submitCount}) => (
                        <Form className="row g-3">
                            <div className="col-md-12">
                                <NsField
                                    name={"mail"}
                                    label={"E-mail*:"}
                                    type={"mail"}
                                    isDisabled={idUsr && !isRuoloSuperAdmin()}
                                    formikRef={formikRef}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                            <div className="col-md-6">
                                <NsField
                                    name={"nome"}
                                    label={"Nome*:"}
                                    formikRef={formikRef}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                            <div className="col-md-6">
                                <NsField
                                    name={"cognome"}
                                    label={"Cognome*:"}
                                    formikRef={formikRef}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                            <div className="col-md-3">
                                <NsField
                                    name={"id_ruolo"}
                                    label={"Ruolo*:"}
                                    as={"select"}
                                    options={(optionsRuoli ? optionsRuoli.map(o => {
                                        return {
                                            label: o.nome,
                                            value: o.id_ruolo,
                                        };
                                    }) : [])}
                                    valueTemplate={(option, props) => {
                                        if (option) {
                                            return <Tag className="mr-2"
                                                        severity={getSeverityRuolo(option.name, optionsRuoli)}
                                                        value={option.name}/>
                                        }
                                        return <span>{props.placeholder}</span>;
                                    }}
                                    itemTemplate={(option) => {
                                        return <Tag className="mr-2"
                                                    severity={getSeverityRuolo(option.name, optionsRuoli)}
                                                    value={option.name}/>
                                    }}
                                    placeholder={translate("Seleziona un ruolo")}
                                    formikRef={formikRef}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                            <div className="col-md-3">
                                <NsField
                                    name={"attivo"}
                                    label={"Utente attivo*:"}
                                    as={"select"}
                                    options={(statiUtenteAttivo ? statiUtenteAttivo.map(o => {
                                        return {
                                            label: o.descrizione,
                                            value: o.id,
                                        };
                                    }) : [])}
                                    valueTemplate={(option, props) => {
                                        if (option) {
                                            if (option.code == 1) {
                                                return <Tag className="mr-2" icon="fas fa-check" severity="success"
                                                            value={translate("Attivo")}/>
                                            } else {
                                                return <Tag className="mr-2" icon="fas fa-times" severity="danger"
                                                            value={translate("Non attivo")}/>
                                            }
                                        }

                                        return <span>{props.placeholder}</span>;
                                    }}
                                    itemTemplate={(option) => {
                                        if (option.code == 1) {
                                            return <Tag className="mr-2" icon="fas fa-check" severity="success"
                                                        value={translate("Attivo")}/>
                                        } else {
                                            return <Tag className="mr-2" icon="fas fa-times" severity="danger"
                                                        value={translate("Non attivo")}/>
                                        }
                                    }}
                                    placeholder={translate("Seleziona")}
                                    formikRef={formikRef}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                        </Form>
                    )}
                </Formik>
            </Card>
            {
                /*
                 * Associazione Utente - Gruppi
                 */
                utente && isIdRuoloOperatore(utente.id_ruolo) &&
                <NsCard
                    title={'Gruppi e permessi'}
                    icon={'fas fa-users'}
                    getBottoniDx={() =>
                        <NsButtonNavigazione
                            nome={"aggiungiOrg"}
                            label={"Aggiungi"}
                            icona={"fas fa-plus-circle"}
                            onClick={onClickAggiungiGruppo}
                        />
                    }>
                    <Formik
                        initialValues={initialValuesFormGrupi}
                        innerRef={formikRefGruppi}
                        onSubmit={onSubmitFormGruppi}
                    >
                        {({errors, touched, values, submitCount}) => (
                            <Form className="row g-3">
                                <div className="col-md-6">
                                    <NsField
                                        name={"id_gruppo_utente"}
                                        label={"Gruppo Utente*:"}
                                        as={"select"}
                                        options={(optionsGruppi ? optionsGruppi.map(o => {
                                            return {
                                                label: o.descrizione,
                                                value: o.id_gruppo_utente,
                                            };
                                        }) : [])}
                                        placeholder={translate("Selezionare un gruppo utente")}
                                        formikRef={formikRefGruppi}
                                        values={values}
                                        errors={errors}
                                        touched={touched}
                                        submitCount={submitCount}
                                    />
                                </div>
                            </Form>
                        )}
                    </Formik>
                    <div className={"pt-3"}>
                        <NsDataTable
                            data={gruppiUtente}
                            columns={[
                                {
                                    name: translate('Codice'),
                                    selector: row => row.codice,
                                    sortable: true,
                                },
                                {
                                    name: translate('Descrizione'),
                                    selector: row => row.descrizione,
                                    sortable: true,
                                },
                                {
                                    name: translate('Note'),
                                    selector: row => row.note,
                                    sortable: true,
                                },
                                {
                                    name: '',
                                    selector: row => <NsButtonActionsGroup>
                                        <li>
                                            <NsButtonAction
                                                label={"Visualizza permessi"}
                                                icona={"fas fa-eye"}
                                                onClick={() => {
                                                    onClickVisualizzaPermessi(row);
                                                }}
                                            />
                                        </li>
                                        <li>
                                            <NsButtonAction
                                                label={"Elimina"}
                                                icona={"fas fa-trash"}
                                                onClick={() => {
                                                    onClickEliminaGruppo(row);
                                                }}
                                            />
                                        </li>
                                    </NsButtonActionsGroup>,
                                    sortable: false,
                                    right: true,
                                }
                            ]}
                        />
                    </div>
                </NsCard>
            }
        </div>
    );
}